import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { v4 } from 'uuid';
import mixpanel from '../../utilities/mixpanel';
import { useNotifications } from '../../hooks/useSystem';
import { useCurrentLocalNotification } from '../../hooks/useApp';
import { RemoveGlobalNotificationMessage } from '../../api/GlobalNotificationMessages';
import { SECONDARY_COLOR } from './constants/_colors';

const useStyles = makeStyles({
  closeContainer: {
    flexGrow: 1,
    textAlign: 'right',
  },
  closeIcon: {
    cursor: 'pointer',
  },
  container: {
    padding: isMobile => (isMobile ? '65px 0 12px' : '12px 0'),
    flexGrow: 2,
    marginLeft: '15px',
    marginRight: '15px',
  },
  header: {
    textAlign: 'center',
  },
  headerBox: {
    backgroundColor: SECONDARY_COLOR,
    padding: '4px',
  },
  headerContainer: {
    alignItems: 'center',
  },
  mainBox: {
    borderColor: SECONDARY_COLOR,
  },
  notifBox: {
    padding: '10px',
  },
});

const SystemNotification = ({ isMobile, margin }) => {
  const [displayNotification, setDisplayNotification] = useState(true);
  const [notifications, setNotifications] = useState(null);
  const localNotifications = useMemo(() => useCurrentLocalNotification(), []);
  const currentNotifications = useNotifications();
  const classes = useStyles(isMobile);

  useEffect(() => {
    let arr = [];
    if (localNotifications && localNotifications.length > 0) {
      arr = arr.concat(localNotifications);
    }
    if (currentNotifications && currentNotifications.length > 0) {
      arr = arr.concat(currentNotifications);
    }
    setNotifications(arr);
  }, [currentNotifications, localNotifications]);

  if (!displayNotification || !notifications || notifications.length === 0) {
    return null;
  }

  const onDismiss = () => {
    mixpanel.track('System Notification Closed');
    setDisplayNotification(false);
    RemoveGlobalNotificationMessage();
  };

  return (
    <Box className={classes.container} m={margin}>
      <Box className={classes.mainBox} border={1}>
        <Box className={classes.headerBox} color="info.contrastText" p={2}>
          <Grid container className={classes.headerContainer}>
            <Grid item xs={1}>
              <InfoIcon />
            </Grid>
            <Grid item className={classes.header} xs={10}>
              System Information
            </Grid>
            <Grid item className={classes.closeContainer}>
              <CloseIcon className={classes.closeIcon} onClick={onDismiss} />
            </Grid>
          </Grid>
        </Box>
        {notifications.map(notification => (
          <Box className={classes.notifBox} key={v4()} p={2} dangerouslySetInnerHTML={{ __html: notification.message }} />
        ))}
      </Box>
    </Box>
  );
};

SystemNotification.propTypes = {
  isMobile: PropTypes.bool,
  margin: PropTypes.number,
};

SystemNotification.defaultProps = {
  isMobile: false,
  margin: 0,
};

export default SystemNotification;
